import React from 'react';
import './SyncErrorsPanel.css';

/**
 * Спрощений компонент для помилок синхронізації
 * В новій системі помилки обробляються через notifications
 */
const SyncErrorsPanel: React.FC = () => {
  // В новій системі помилки показуються через notifications
  // Цей компонент залишаємо для майбутнього розширення
  return null;
};

export default SyncErrorsPanel;
